module.exports = __webpack_public_path__ + "assets/img/button.c4879708.jpg";